import { PlanoBemEstarBrandingLargeIcon } from '@ferreri/prever-component-lib';
import { usePlanDetails } from '..';

export const PlanoBemEstarDetails: usePlanDetails = {
  name: 'Bem Estar',
  basePrice: 84,
  title: 'Economia para cuidar da sua saúde e de quem você ama.',
  description:
    'Faça planos com a família, com cuidado e proteção especiais em saúde.',
  heroUri: 'assets/img/bem-estar.webp',
  icon: <PlanoBemEstarBrandingLargeIcon />,
  buyButtonLabel: 'Contratar Bem Estar',
  includedDependents: {
    description:
      'Contratante (titular), cônjuge, filhos solteiros, pais, sogros e até dois dependentes (netos ou sobrinhos), até 25 anos com dependência financeira do titular, estão incluídos no valor da mensalidade. Você ainda pode simular a adição de outros dependentes.',
    alert:
      'Além do titular deve haver ao menos 1 dependente maior de 18 anos e não curatelado.',
  },
  benefits: [
    {
      title: 'Condições para inclusão de outros dependentes.',
      items: [
        'Até 2 dependentes com grau de parentesco (neto ou sobrinho), acima de 25 anos: adicional de 10% por dependente.',
        'Até 5 dependentes com ou sem grau de parentesco até 79 anos: adicional de 30% por dependente;',
        'Dependentes adicionais a partir de 80 anos (na data de adesão do plano): adicional de 80% por dependente (exceto pais e sogros).',
      ],
    },
    {
      title: 'Cobertura e assistências',
      items: [
        'Translado até 200km',
        'Teleconsultas',
        'Orientação jurídica',
        'Acolhimento ao luto',
        'Apoio ortopédico',
        'Assistência funeral',
        'Seguro acidentes pessoais',
        'Seguro fratura óssea',
        'Seguro invalidez permanente',
      ],
    },
    {
      title: 'Beneficiários',
      description:
        'Pai, mãe, sogro, sogra, filhos solteiros e até dois dependentes com grau de parentesco (neto ou sobrinho), até 25 anos incluso no valor da mensalidade, desde que residam sob dependência financeira do titular.',
    },
    {
      title: 'Assistência funeral',
      items: [
        'Cobertura nacional',
        'Atendimento funerário 24 horas',
        'Assessoria para realização do funeral',
        'Urna com alça varão e visor',
        'Ornamentação de urna',
        'Paramentos para cerimônia fúnebre',
        'Tanatopraxia inclusa',
        'Coroa de flores com faixa de homenagem',
        'Orientação do processo de Registro de Óbito',
        'Veículo para remoção',
        'Translado incluso em raio de 200km de distância',
        'Local para velório',
        'Carência de 24 horas para morte acidental',
        'Carência de 90 dias para óbito na região Sul',
        'Carência de 12 meses para óbito fora da Região Sul',
      ],
    },
    {
      title: 'Angelus Memorial e Crematório',
      items: [
        '9 capelas para velório com espaço reservado para a família;',
        'Suítes privativas para descanso;',
        'Segurança e monitoramento 24h;',
        'Serviço de copa;',
        'Equipe de apoio durante o velório;',
        'Infraestrutura para velório online.',
      ],
    },
    {
      title: 'Assistência Sepultamento',
      description:
        'Titular ou dependentes do plano podem optar, caso desejarem, pela cremação ou locação trienal de jazigo. Nas cidades onde a contratada não possua cemitérios e crematórios próprios ou parceiros indicados, o associado terá direito há uma cobertura de até R$ 3.000,00 (três mil reais), para locação de jazigo ou cremação. Benefício não incluído no plano. Consulte as condições para a adesão da Assistência Sepultamento.',
      items: [],
      alert: '',
    },
    {
      title: 'Benefícios em vida',
      description:
        'Além da assistência funeral, você garante benefícios em vida para aproveitar melhor os dias, sem se preocupar.',
      items: [
        {
          title: 'Desconto em medicamentos',
          description:
            'Aproveite mais de 2.000 medicamentos com até 80% de desconto na rede de Farmácias credenciadas!',
        },
        {
          title: 'Clube de vantagens',
          description:
            'O Clube de vantagens Angeplus oferece para todos os associados descontos e vantagens para comprar e vender com economia. É fácil, rápido e gratuito!',
        },
      ],
    },
    {
      title: 'Acolhimento ao luto',
      items: [
        'Acompanhamento psicológico de aconselhamento e suporte que auxilia titulares e dependentes no processo do luto com 3 sessões remotas individuais e gratuitas.',
      ],
    },
    {
      title: 'Assistência de apoio ortopédico',
      items: [
        'Empréstimo de equipamento ortopédico gratuito por 30 dias: cadeira de banho, cadeira de rodas, andador 3 barras. Nas cidades onde a contratada possua operação própria de atendimento.',
      ],
    },
    {
      title: 'Teleconsultas gratuitas',
      items: [
        'Através do APP Angeplus, em "Cuidados e Saúde" você tem acesso às teleconsultas gratuitas disponíveis para o seu plano. São mais de 30 especialidades médicas com acionamento ilimitado.',
      ],
    },
    {
      title: 'Orientação jurídica pós-óbito',
      items: [
        'Profissionais do Direito disponíveis para orientações sobre dúvidas legais relacionadas ao óbito.',
      ],
    },
    {
      title: 'Seguro de acidentes pessoais',
      items: [
        'Ampare financeiramente quem você ama no doloroso momento da despedida com o Seguro de Acidentes Pessoais.',
        'Tenha cobertura de R$10.000,00 em caso de morte acidental do titular do plano e cobertura de R$10.000,00 em caso de morte acidental do cônjuge do titular.',
      ],
    },
    {
      title: 'Seguro fratura óssea',
      items: [
        'Cobertura de até R$1.500,00 em caso de fratura óssea por acidente do titular do plano.',
        'Cobertura de até R$1.500,00 em caso de fratura óssea por acidente do cônjuge do titular.',
      ],
    },
    {
      title: 'Seguro invalidez permanente por acidente',
      items: [
        'Cobertura de até R$10.000,00 em caso de perda, redução ou impotência total ou parcial de um membro ou órgão causada por lesão física do titular do Plano.',
        'Cobertura de até R$10.000,00 em caso de perda, redução ou impotência total ou parcial de um membro ou órgão causada por lesão física do cônjuge do titular.',
      ],
    },
    {
      title: 'Seguros',
      items: ['Fratura ossea', 'Invalidez', 'Acidentes pessoais'],
    },
  ],
};
